import axios from "./axios"

/**
 * 獲取用戶問卷
 * @param {*} lang 
 */
const listUserQuestionnaires = (lang = 'ZH_TW') => {
    return axios.get(`/user-questionnaires?lang=${lang}`).then(res => res.data)
}

/**
 * 用戶提交課程問卷
 * @param {*} answerValues 
 * @param {*} lang 
 */
const submit = (answerValues, lang = 'ZH_TW') => {
    return axios.post(`/user-questionnaires/submit?lang=${lang}`, answerValues).then(res => res.data)
}

/**
 * 用戶參與課程問卷
 * @param {*} lang 
 */
const listQuestionByQuestionnaire = (questionnaireId, lang = 'ZH_TW', group) => {
    return axios.get(`/user-questionnaires/${questionnaireId}/questions?lang=${lang}${group ? `&group=${group}`:''}`).then(res => res.data)
}

export default {
    listUserQuestionnaires,
    submit,
    listQuestionByQuestionnaire
}